import Vue from 'vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import StarRating from 'vue-star-rating/src/star-rating.vue';
import { BootstrapVue } from 'bootstrap-vue'
import App from './App.vue';
import vSelect from 'vue-select';

import carousel from 'v-owl-carousel';
import VueProgressBar from 'vue-progressbar';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';


// css and scss files include
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/font-awesome.min.css'
import './assets/index.scss'
import {
  faNewspaper,
  faBell,
  faCheck, faPhoneAlt, faMapMarkedAlt, faEnvelope, faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faNewspaper,
  faBell,
  faCheck,
  faPhoneAlt,
  faMapMarkedAlt,
  faEnvelope,
  faSignOutAlt
);

Vue.use(BootstrapVue);
Vue.component('carousel', carousel);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('star-rating', StarRating);
Vue.component('v-select', vSelect);

Vue.config.productionTip = false;
const options = {
  color: '#7DEADF',
  failedColor: '#7DEADF',
  thickness: '4px',
  transition: {
    speed: '0.5s',
    opacity: '0.10s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};
Vue.use(VueProgressBar, options);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
